<div class="p-3">

  <!-- MODO MÊS -->
  <div *ngIf="!modoManual">

    <div *ngFor="let tipo of tipos" class="mb-3">

      <div class="d-flex justify-content-between mb-2">

        <label class="text-muted mb-0">
          <i class="fas {{ getConfigTipo(tipo).icon }} mr-1"></i>
          Mês de {{ getConfigTipo(tipo).label }}

          <!-- PERÍODO -->
          <span *ngIf="mesesSelecionados[tipo]?.length">
            <span class="mr-2">:</span>
            <small class="badge badge-light border px-2 py-1">
              <i class="fas fa-calendar-day mr-1"
                [ngClass]="'text-' + getConfigTipo(tipo).color">
              </i>{{ getPeriodoTexto(tipo) }}
            </small>
          </span>
        </label>

      </div>

      <div class="d-flex flex-wrap">

        <button *ngFor="let mes of mesesRapidos"
                type="button"
                class="btn btn-sm mr-2 mb-2 btn-filtro-toggle"
                [class]="'btn btn-sm mr-2 mb-2 ' + 
                  (mesesSelecionados[tipo]?.includes(mes.value) 
                    ? 'btn-' + getConfigTipo(tipo).color 
                    : 'btn-outline-' + getConfigTipo(tipo).color)"
                (click)="toggleMes(tipo, mes.value)">

          {{ mes.label }}

        </button>

      </div>

    </div>

  </div>

  <!-- MODO MANUAL -->
  <div *ngIf="modoManual" class="card p-3 mt-2 border mb-0">

    <h6 class="text-muted mb-3">
      <i class="fas fa-sliders-h mr-1"></i>
      Filtro manual
    </h6>

    <div class="row">
      <ng-container *ngFor="let tipo of tipos">

        <div class="col-md-3 mb-1">
          <label>{{ getConfigTipo(tipo).label }} (De):</label>
          <input type="date"
                class="form-control"
                [(ngModel)]="filters[tipo].ini"
                (change)="emitChange()">
        </div>

        <div class="col-md-3 mb-1">
          <label>{{ getConfigTipo(tipo).label }} (Até):</label>
          <input type="date"
                class="form-control"
                [(ngModel)]="filters[tipo].fim"
                (change)="emitChange()">
        </div>

      </ng-container>
    </div>

  </div>

  <!-- BOTÕES -->
  <div class="mt-3">

    <button type="button"
            class="btn btn-sm btn-outline-secondary mr-2"
            (click)="modoManual = !modoManual">

      <i class="fas fa-sliders-h mr-1"></i>
      {{ modoManual ? 'Usar seleção por mês' : 'Selecionar datas manualmente' }}

    </button>

    <!-- MULTI -->
    <ng-container *ngIf="initStateMulti == false">
      <ng-container *ngFor="let tipo of tipos">
        <button *ngIf="!modoManual"
                type="button"
                class="btn btn-sm mr-2 btn-filtro-toggle"
                [class]="'btn btn-sm mr-2 ' + 
                  (multi[tipo] 
                    ? 'btn-' + getConfigTipo(tipo).color 
                    : 'btn-outline-' + getConfigTipo(tipo).color)"
                (click)="multi[tipo] = !multi[tipo]">

          <i class="fas fa-layer-group mr-1"></i>
          Múltiplos meses ({{ getConfigTipo(tipo).label }})
        </button>
      </ng-container>
    </ng-container>

    <!-- LIMPAR -->
    <button type="button"
            class="btn btn-sm btn-outline-secondary mr-2"
            (click)="limpar()">

      <i class="fas fa-eraser mr-1"></i>
      Limpar Filtros
    </button>

    <!-- PESQUISAR -->
    <button *ngIf="mostrarPesquisar"
            type="button"
            class="btn btn-sm btn-primary mr-2"
            (click)="pesquisarDados()">

      <i class="fas fa-search mr-1"></i>
      Pesquisar
    </button>

    <!-- EMITIR -->
    <button *ngIf="mostrarEmitir"
            type="button"
            class="btn btn-sm btn-dark"
            (click)="emitirRelatorio()">

      <i class="fas fa-file-export mr-1"></i>
      Emitir Relatório
    </button>

</div>